define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action",
	"csi/locale",
	"csi/reflection",
	"csi/table/SwitchboardWidget",
	"csi/xml",
	"SiteAdmin/Locale",
	"./_Store",
	"./_TableMixin",

	"csi/view/ToolbarFind"
], function(declare, _, csiAction, locale, reflection, Switchboard, xml, Locale, _Store, _TableMixin) {

	var _typeResults,

		_ClassStore = declare(_Store, {
			bParameterized: false,
			keyConfig: "Name",

			getResourceAttribute: function() {
				// summary: return attribute
				return Locale.ATTR_TYPES;
			},

			getResourceKeys: function(/*Node*/node, /*String*/keyContainer) {
				// summary: return array of keys used to persist resource
				return [node.Id, keyContainer];
			},

			_getResource: function(/*Node*/node, /*LocaleResolver*/lr) {
				// summary: get resource for key from resolver
				return lr.getTypeName(node.Id);
			},

			_resolveData: function(/*Deferred*/dfd) {
				// summary: create items for store from all enabled, non-private classes with explicit Name
				if (!_typeResults) {
					_typeResults = [];

					_.each(this.lrBaseSite.localeResources.types, function(value, key) {
						var rc = reflection.getClass(key);
						if (rc?.enabled && !rc.isPrivate() && value.Name) {
							_typeResults.push(key);
						}
					});

					_typeResults.sort();
				}

				var data = _.map(_typeResults, this._createNode, this);

				dfd.resolve(data);
			},

			onPut: function(/*Node*/node, /*Object*/res) {
				// summary: add class plural and tooltip resources
				var plural = locale.TYPE_PLURAL;
				var tooltip = locale.TYPE_TOOLTIP;
				var type = node.Id;

				// if name is specified but plural is not, then show base plural value and highlight
				var x = res[plural] = this.lrConfig.getTypeResource(type, plural);

				node["Css" + plural] = false;

				if (!x && res.Name) {
					if (res[plural] = this.lrBase.getTypeResource(type, plural) || "") {
						node["Css" + plural] = true;
					}
				}

				res[tooltip] = this.lrConfig.getTypeResource(type, tooltip) || "";
			}
		});

	return declare([Switchboard, _TableMixin], {
		bUseLocation: false,
		storeClass: _ClassStore,

		selectClass: function(/*String*/type) {
			// summary: update selected class after resetting filter
			this.get("store").query({Id: type}).forEach(function(node) {
				var findPlugin = this.getPlugin("find");
				if (findPlugin.get("value")) {
					this.urlPreSelect = node.$URL;
					this.getPlugin("find").set("value", "");
				} else {
					csiAction.invoke(this, this.getRefNodeByUrl(node.$URL), this.ACTION_SELECT);
				}
			}, this);
		},

		_onAccessActionPlural: function(/*Context*/ctx, /*Action*/action) {
			// summary: don't allow editing of type plural if not already specified in base
			var plural = Locale.getBaseConfigResolver().getTypePlural(ctx.getNode().Id);
			return !!plural;
		},

		_switchSelect: function(/*Node*/node) {
			// summary: replace LocaleConfiguration node with node for reflection class so switchboard can load attributes view
			node = xml.nodeCreateClientNode(reflection.getClassUrl(node.Id), reflection.TYPE_BUSINESS_OBJECT, node.Id);
			return this.inherited(arguments, [node]);
		}
	});
});